import type {
  GetStampCardRequest,
  GetStampCardResponse,
  PostStampCardRequest,
  PostStampCardResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getStampCard = sendRequest<GetStampCardRequest, GetStampCardResponse>({
  url: '/stamp_card',
  method: 'get',
});

export const postStampCard = sendRequest<PostStampCardRequest, PostStampCardResponse>({
  url: '/stamp_card',
  method: 'post',
});
